// Pass purchase costs
export const PASS_COSTS = {
  crew: { tokenType: 'crewmate', amount: 35 },
  impostor: { tokenType: 'impostor', amount: 15 },
};

// Reward types: 'tokens', 'lootbox', 'item'
// Items reference passExclusive SVG items in lootbox.js
//
// Balance target: ~300% ROI for both passes (equalized).
//   CrewPass  (35 crew cost):  ~80 crew tokens + 38 lootbox value = 118 → 337%
//   ImpPass   (15 imp = 60 crew equiv): ~27 imp tokens (108 equiv) + 53 normal boxes + 38 lootbox = 199 → 332%
// Both passes feel rewarding without printing money.

// Shared lootbox schedule (tiers that aren't items or tokens)
const LOOTBOX_TIERS = {
  5: 'normal', 15: 'normal', 35: 'normal', 45: 'normal',
  55: 'shiny', 65: 'shiny', 85: 'shiny', 95: 'elite',
};

const ITEM_TIERS = new Set([10, 20, 25, 30, 40, 50, 60, 70, 75, 80, 90, 100]);

function generateRewards(passType) {
  const tokenType = passType === 'crew' ? 'crewmate' : 'impostor';
  const isCrew = passType === 'crew';
  const passPrefix = isCrew ? 'crew' : 'impostor';
  const rewards = [];

  for (let tier = 1; tier <= 100; tier++) {
    const entry = { tier, rewards: [] };

    if (ITEM_TIERS.has(tier)) {
      // Item milestone — exclusive SVG art only
      entry.rewards.push({ type: 'item', itemId: `${passPrefix}_pass_${tier}` });
    } else if (LOOTBOX_TIERS[tier]) {
      // Scheduled lootbox tier
      entry.rewards.push({ type: 'lootbox', lootboxType: LOOTBOX_TIERS[tier], amount: 1 });
    } else if (isCrew) {
      // CrewPass: 1 crewmate token per remaining tier (~80 total)
      entry.rewards.push({ type: 'tokens', tokenType, amount: 1 });
    } else {
      // ImpostorPass: impostor tokens every 3rd tier, normal lootbox otherwise
      // Balances the 4x impostor token multiplier so both passes have ~same ROI
      if (tier % 3 === 1) {
        entry.rewards.push({ type: 'tokens', tokenType, amount: 1 });
      } else {
        entry.rewards.push({ type: 'lootbox', lootboxType: 'normal', amount: 1 });
      }
    }

    rewards.push(entry);
  }

  return rewards;
}

export const CREW_PASS_REWARDS = generateRewards('crew');
export const IMPOSTOR_PASS_REWARDS = generateRewards('impostor');

export function getPassRewards(passType) {
  return passType === 'crew' ? CREW_PASS_REWARDS : IMPOSTOR_PASS_REWARDS;
}
